import { observable, action } from 'mobx'
import { configure } from "mobx";
import { FacultyPageStore } from './FacultyPageStore';
import { Application } from 'src/core/application';

configure({
    enforceActions: "always"
});

export class AppStore {
       
    @observable public facultyPageStore: FacultyPageStore;
    @observable public isLoggedIn: boolean; 
    @observable public isAgreed: boolean; 

    constructor(){
        this.init();
    }

    @action
    private init() {
        this.facultyPageStore = new FacultyPageStore();
        this.isLoggedIn = Application.isLoggedIn();
    }

    @action
    public setIsLoggedIn(isLoggedIn: boolean) {
        this.isLoggedIn = isLoggedIn;
    }

    @action
    public setIsAgreed(isAgreed: boolean) {
        this.isAgreed = isAgreed;
    }

}

export const appStore = new AppStore()



// WEBPACK FOOTER //
// ./src/mobx/AppStore.ts